import { DialogContent } from "@mui/material";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import LoadingState from "./LoadingState";
import TransactionDetails from "./TransactionDetails";

interface ModalContentProps {
    isLoading: boolean;
    transactionData: any;
}

const ModalContent = ({ isLoading, transactionData }: ModalContentProps) => {
    return (
        <DialogContent dividers sx={{ borderColor: '#333', backgroundColor: '#1e1e1e' }}>
            {isLoading ? (
                <LoadingState />
            ) : transactionData ? (
                <TransactionDetails transaction={transactionData} />
            ) : (
                <StackKit alignItems="center" justifyContent="center" sx={{ py: 8 }}>
                    <TypoGraphyKit>اطلاعاتی یافت نشد</TypoGraphyKit>
                </StackKit>
            )}
        </DialogContent>
    );
};

export default ModalContent;